import React, { Component } from "react";
import { connect } from "react-redux";
import { createWord } from "../../store/actions/wordAction";

import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

import { createCSVWords } from "../../store/actions/wordAction";

export class csvGoogle extends Component {
  state = {
    multiline: "",
    multiline2: "",
    multiline3: "",
    multiline4: "",
    Language1: "",
    Language2: "",
    set: "",
    sets: [{ id: "3", name: "3" }]
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleChangeSelect = event => {
    console.log(event);
    this.setState({
      set: event.target.value
    });
  };

  componentWillReceiveProps(nextProps) {
    //  alert("asas");
    this.setState({
      sets: nextProps.sets
    });
  }




  handleSubmitGoogleCSV = e => {
    e.preventDefault();
    let words = [];
    // let word ={};
    let left;
    let right;
    var n;
    var i = 0;
    let word1 = {};
    let textLeft=this.state.multiline.split("\n");
    let textRight = this.state.multiline2.split("\n")
    let description1=this.state.multiline3.split("\n");
    let description2=this.state.multiline4.split("\n");

    let textLine=this.state.multiline.split("\n");
    console.log(textLine);
    textLeft.map((line, key) => {
 
      word1 = {};
      word1.Language1="";
      word1.Language2="";
      word1.Language3="";
      word1.Language4="";
      word1.Language5="";
      word1.Description1="";
      word1.Description2="";
      word1.Description3="";
      word1.Description4="";
      word1.Description5="";

      let section=textLine[i].split("|");
      console.log(textLine[i]);
      console.log(section);
      if(section[0]=="Spanisch"){
        word1.Language1 = section[2].trim();
      }
      else if(section[0]=="Deutsch"){
        word1.Language2 = section[2].trim();
      }
      else if(section[0]=="Englisch"){
        word1.Language3 = section[2].trim();
      }
      else if(section[0]=="Französisch"){
        word1.Language4 = section[2].trim();
      }
      else if(section[0]=="Italienisch"){
        word1.Language5 = section[2].trim();
      }
      

      if(section[1]=="Spanisch"){
        word1.Language1 = section[3].trim();
      }
      else if(section[1]=="Deutsch"){
        word1.Language2 = section[3].trim();
      }
      else if(section[1]=="Englisch"){
        word1.Language3 = section[3].trim();
      }

      else if(section[1]=="Französisch"){
        word1.Language4 = section[3].trim();
      }
      else if(section[1]=="Italienisch"){
        word1.Language5 = section[3].trim();
      }


      word1.set = this.state.set;
      word1.bookmarked = false;
      word1.level =1;
      words.push(word1);
    
      i++;
  })


    this.props.createCSVWords(words);
  };





  render() {
    // const handleChange = name => event => {
    //  //   setValues({ ...values, [name]: event.target.value });

    //   };

    return (
      <Paper className="paper-container">
        <div className="container">
          <form className="white" onSubmit={this.handleSubmitGoogleCSV}>
            <TextField
              fullWidth
              id="multiline"
              label="Multiline"
              multiline
              rowsMax="40"
              value={this.state.multiline}
              onChange={e => this.handleChange(e)}
              className="multiline-csv"
              margin="normal"
            />


            <br></br>
            <br></br>

            <FormControl>
              <InputLabel htmlFor="name-simple">Set</InputLabel>
              <Select
                value={this.state.set}
                onChange={this.handleChangeSelect}
                inputProps={{
                  name: "name",
                  id: "name-simple"
                }}
              >
                {typeof this.state.sets != "undefined" &&
                  this.state.sets.map(se => (
                    <MenuItem value={se.name}>{se.name}</MenuItem>
                  ))}

                {/* 

                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem> */}
              </Select>
            </FormControl>

            <br></br>
            <br></br>

            <Button
              type="submit"
              value="Submit"
              variant="contained"
              color="secondary"
            >
              Create
            </Button>
          </form>
        </div>
      </Paper>
    );
  }
}

const mapStateToProps = state => {
  //  console.log(state.firestore);
  //console.log(this.state.words);
  return {
    sets: state.firestore.ordered.sets
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createCSVWords: words => dispatch(createCSVWords(words))
  };
};

//   export default connect(null, mapDispatchToProps)(NewWord)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    {
      collection: "sets"
    }
  ])
)(csvGoogle);

//export default csv
